import { Search as SearchIcon } from '@mui/icons-material';
import { Box, InputAdornment, styled, TextField } from '@mui/material';
import DocumentActionButtons from './DocumentActionButtons';
import { DocumentToolbarProps } from './types';

const ToolbarRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

const DocumentToolbar = ({ currentDocuments, searchQuery, onSearchChange }: DocumentToolbarProps) => (
  <ToolbarRow>
    <DocumentActionButtons currentDocuments={currentDocuments} />
    <TextField
      size="small"
      placeholder="Search documents..."
      value={searchQuery}
      onChange={e => onSearchChange(e.target.value)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
      sx={{ marginLeft: 'auto', width: 260 }}
    />
  </ToolbarRow>
);

export default DocumentToolbar;
